import React, { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { forwardRef, useImperativeHandle } from "react";
import UiContext from "../store/ui-context";
import { Password } from "primereact/password";
import { FaUserShield } from "react-icons/fa6";
import useAPIRequest from "../custom_hooks/simple/useAPIRequest";

const title = "Verif Authorization";

const VerifAuthorizationDialog = (props) => {
  const { loading, errorMessage } = props;
  const uiContext = useContext(UiContext);
  const passwordInputRef = useRef(null);
  const visible = uiContext.visibleVerifAuthDialog;
  const { verifLabel, onConfirm } = uiContext.propsVerifAuthDialog;
  const [inputUsername, setInputUsername] = useState("");
  const [inputPassword, setInputPassword] = useState("");

  useEffect(() => {
    if (visible) {
      setInputUsername("");
      setInputPassword("");
    }
  }, [visible]);

  const onHide = () => {
    uiContext.hideVerifAuthDialog();
  };

  const handleConfirm = async (event) => {
    if (onConfirm) {
      const value = await onConfirm({
        username: inputUsername.trim(),
        password: inputPassword.trim(),
      });
      if (!value) {
        setInputPassword("");
        passwordInputRef.current.focus();
      } else {
        onHide();
      }
    }
  };

  const handleOnKeyDownUsernameInput = (event) => {
    if (event.keyCode === 13) {
      passwordInputRef.current.focus();
    }
  };

  const handleOnKeyDownPasswordInput = (event) => {
    if (event.keyCode === 13) {
      handleConfirm();
    }
  };

  const dialogFooter = (
    <div className="row-between-center w-100">
      <Button
        className="w-100"
        label="Berikan Otorisasi"
        loading={loading}
        icon="pi pi-lock-open"
        onClick={handleConfirm}
      />
      <Button
        loading={loading}
        icon="pi pi-arrow-left"
        outlined
        onClick={onHide}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "20rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={"Otorisasi Verifikasi"}
      closeOnEscape={false}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      closable={false}
    >
      <div className="col-start-center w-100 relative h-100 gap-3 pt-2">
        <div className="col-center-center gap-5">
          <FaUserShield className="text-indigo-500" size={100} />
          <span className="text-indigo-500 font-bold text-xs">
            LOGIN UNTUK BERIKAN OTORISASI
          </span>
        </div>
        <div className="row-start-center p-inputgroup w-100">
          <i className="p-inputgroup-addon pi pi-user"></i>
          <InputText
            readOnly={loading}
            placeholder="Username"
            id="username"
            aria-describedby="username-help"
            onChange={(e) => setInputUsername(e.target.value)}
            autoFocus
            onKeyDown={handleOnKeyDownUsernameInput}
          />
        </div>

        <div className="row-start-center p-inputgroup w-100">
          <i className="p-inputgroup-addon pi pi-key"></i>
          <Password
            ref={passwordInputRef}
            readOnly={loading}
            value={inputPassword}
            feedback={false}
            placeholder="Password"
            id="password"
            onChange={(e) => setInputPassword(e.target.value)}
            onKeyDown={handleOnKeyDownPasswordInput}
          />
        </div>

        {/* <h1> Hello bro, this is authorization dialog </h1> */}
        {/* <InputText
          // disabled={loading}
          readOnly={loading}
          className="text-center"
          autoFocus
          placeholder="Scan Barcode"
          value={barcode}
          onChange={handleInputChange}
          ref={inputRef}
          onKeyDown={handleKeyDown}
        /> */}
      </div>
    </Dialog>
  );
};

export default VerifAuthorizationDialog;
